import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  Button,
  Header,
  Modal,
} from 'semantic-ui-react';
import { fetchM, serverRequestPut } from '../../actions/fetchM';
import config from '../../../config';
import moment from 'moment-timezone';

class AddBankerAnnouncement extends Component {
  static propTypes = {
    auth: PropTypes.shape({
      preferredName: PropTypes.string,
    }),
    show: PropTypes.bool,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
  })
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      token: null,
    };
  }
  componentWillReceiveProps(nextProps) {
    this.fetchProfile();
    const { show } = nextProps;
    this.setState({
      show,
    });
  }

  async fetchProfile() {
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('apiURL')}/profile/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
    }
    if (res.ok) {
      const token = res.headers.get('X-Csrf-Token');
      this.setState({
        token,
      });
    }
  }
  handleOnClose = async (showBankers) => {
    const { store } = this.context;
    try {
      await serverRequestPut(
        `${config.get('apiURL')}/profile/`,
        store,
        this.state.token,
        { announcementAddBanker: `${moment().format('YYYY-MM-DDTHH:mm:ss')}Z` },
      );
    } catch (e) {
      Bugsnag.notifyException(e);
    }
    this.setState({
      show: false,
    }, () => {
      if (showBankers) {
        store.dispatch(push('/preferred_bankers/'));
      }
    });
  }

  render() {
    const { show } = this.state;
    const { auth } = this.props;
    return (
      <Modal
        size="small"
        open={show}
        onClose={this.handleOnClose}
      >
        <Header content={`Hello ${auth.preferredName}`} />
        <Modal.Content>
          <Modal.Description>
            Welcome to MHub, a people-powered property platform! To get started, you may add or invite your preferred bankers by clicking the button below.
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button positive onClick={() => this.handleOnClose(true)} content={'Add Banker'} />
          <Button onClick={() => this.handleOnClose(false)} content={'Close'} />
        </Modal.Actions>
      </Modal>
    );
  }

}

export default connect(AddBankerAnnouncement.mapStateToProps)(AddBankerAnnouncement);



// WEBPACK FOOTER //
// ./src/components/Announcements/AddBankerAnnouncement.jsx